import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'
import {Text} from '@daedalus/atlas/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

interface Props {
  placeName?: string
}

const Container = styled('div')(
  ({theme}) => css`
    margin-bottom: ${theme.layout.spacing.s300}px;
  `
)

const TitleWrapper = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const LocationTitleSkeleton = () => (
  <Container>
    <SkeletonLoader height={28} />
  </Container>
)

const Title = ({placeName}: Props) => {
  if (placeName) {
    return (
      <Text variant="titleM">
        <FormattedMessageWrapper
          id="latestDeals"
          defaultMessage="Latest deals in {placeName}"
          values={{
            placeName
          }}
        />
      </Text>
    )
  }
  return (
    <Text variant="titleM">
      <FormattedMessageWrapper
        id="recommendationsTitle"
        defaultMessage="Recommendations"
      />
    </Text>
  )
}

export const LocationTitle = ({placeName}: Props) => {
  return (
    <Container>
      <TitleWrapper>
        <Title placeName={placeName} />
      </TitleWrapper>
    </Container>
  )
}
